import { render, staticRenderFns } from "./EliminarCodigos.vue?vue&type=template&id=2cc78ba7&scoped=true"
import script from "./EliminarCodigos.vue?vue&type=script&lang=js"
export * from "./EliminarCodigos.vue?vue&type=script&lang=js"
import style0 from "./EliminarCodigos.vue?vue&type=style&index=0&id=2cc78ba7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc78ba7",
  null
  
)

export default component.exports